<template>
  <div class="page flex-col">
    <HeadVue></HeadVue>
    <div class="group_1 flex-col">
      <div class="text-wrapper_3 flex-col">
        <div class="text-wrapper_31 flex-col"><span class="text_11">模板介绍</span></div>
      </div>
      <div style="margin-left: -120px;">
        <div class="block_11 flex-row justify-between">
          <div class="group_11 flex-row">
            <div v-for="(item, index) in btnList" :key="index"
              :class="['text-wrapper_4', { active: currentIndex === index }]" @click="handleClick(index)">
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
        <div class="section_6 flex-row justify-between">
          <span class="text_19">搜索</span>
          <input class="text-wrapper_11" type="text" v-model="searchText" placeholder="请输入你需要产品名称">
        </div>
        <div class="text-wrapper_32 flex-row">
          <button v-for="(item, index) in filterList" :key="index"
            :class="['filter-btn', { active: filterIndex === index }]" @click="handleFilterClick(index)">
            {{ item }}
          </button>
        </div>
        <div class="image-wrapper_3 flex-row">
          <img class="image_3" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG3816194560e1d6679355e2b80ec7effa.png" />
          <img class="image_4" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG3816194560e1d6679355e2b80ec7effa.png" />
          <img class="image_5" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG3816194560e1d6679355e2b80ec7effa.png" />
          <img class="image_6" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG3816194560e1d6679355e2b80ec7effa.png" />
        </div>
        <div class="section_7 flex-row">
          <div class="text-wrapper_13 flex-col">
            <span class="text_25">ERP(MTO)</span>
            <span class="text_info">
              面向按订单生成的企业ERP管理系统，提供便捷友好的BOM设计功能，精准控制生产过程，物料、中间产物和成品。
            </span>
            <span class="text_27">¥20000</span>
          </div>
          <div class="text-wrapper_14 flex-col">
            <span class="text_28">ERP(MTS)</span>
            <span class="text_info">
              面向常见的按库存生产的企业ERP管理系统，结合制造流程，提供多维度的生成计划以及库存预警。
            </span>
            <span class="text_27">¥30000</span>
          </div>
          <div class="text-wrapper_15 flex-col">
            <span class="text_31">产品设计</span>
            <span class="text_info">满足实体产品的设计与制造过程，提供了图纸设计，产品BOM设计、工艺路线、成本计算。</span>
            <span class="text_33">免费</span>
          </div>
          <div class="box_9 flex-col">
            <div class="text-group_8 flex-col justify-between">
              <span class="text_34">品质售后</span>
              <span class="text_info">管理采购入库的品质和销售的售后服务，解决采销问题。</span>
            </div>
            <span class="text_36">免费试用30天</span>
          </div>
        </div>
        <div class="image-wrapper_4 flex-row">
          <img class="image_7" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG3816194560e1d6679355e2b80ec7effa.png" />
          <img class="image_8" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG3816194560e1d6679355e2b80ec7effa.png" />
          <img class="image_9" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG3816194560e1d6679355e2b80ec7effa.png" />
          <img class="image_10" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG3816194560e1d6679355e2b80ec7effa.png" />
        </div>
        <div class="section_8 flex-row">
          <div class="group_4 flex-col">
            <div class="text-group_9 flex-col justify-between">
              <span class="text_37">关务AEO</span>
              <span class="text_38">提供一站式报关服务，综合解决进出口业务报关问题</span>
            </div>
            <span class="text_39">¥60000</span>
          </div>
          <div class="group_5 flex-col">
            <div class="text-group_10 flex-col justify-between">
              <span class="text_40">制造执行</span>
              <span class="text_41">控制设备的制造执行过程，包含调度、排产和控制系统</span>
            </div>
            <span class="text_42">¥10000</span>
          </div>
          <div class="group_6 flex-row">
            <div class="text-group_11 flex-col">
              <span class="text_43">进销存（采购计划）</span>
              <span class="text_44">对于存在固定客户的企业中，往往需要编制采购计划以应对未来诸多客户的需求变动。</span>
              <span class="text_45">¥30000</span>
            </div>
          </div>
          <div class="group_7 flex-row">
            <div class="text-group_12 flex-col">
              <span class="text_46">HRM人力资源管理系统</span>
              <span class="text_47">覆盖人事招聘、薪资绩效、人事花名册等模块，帮助企业HR轻松完成人力资源管理。</span>
              <span class="text_48">免费试用30天</span>
            </div>
          </div>
        </div>
        <div class="section_9 flex-row">
          <span class="text_49">共&nbsp;88&nbsp;项数据</span>
          <div class="section_1">
            <select v-model="selectedPageSize" class="page-select">
              <option v-for="size in pageSizes" :key="size" :value="size">
                {{ size }}条/页
              </option>
            </select>
            <img class="select-arrow" referrerpolicy="no-referrer" src="./assets/img/pageDown.png" />
          </div>
          <img class="thumbnail_2" referrerpolicy="no-referrer" src="./assets/img/pageLeft.png" />
          <div v-for="page in 5" :key="page" :class="['text-wrapper_' + (page + 15), { active: currentPageNum === page }]"
            @click="handlePageNumClick(page)">

            <span :class="'text_' + (page + 49)">{{ page }}</span>

          </div>
          <img class="thumbnail_3" referrerpolicy="no-referrer" src="./assets/img/ellipsis.png" />
          <div :key="page" :class="['text-wrapper_21', { active: currentPageNum === 11 }]"
            @click="handlePageNumClick(11)">

            <span :class="'text_55'">{{ 11 }}</span>

          </div>

          <img class="thumbnail_4" referrerpolicy="no-referrer" src="./assets/img/pageRight.png" />
          <div class="section_2 flex-row">
            <span class="text_56">跳至</span>
            <input v-model="jumpPage" class="text-wrapper_22" type="number" :min="1" :max="totalPages"
              @keyup.enter="handleJumpPage" />
            <span class="text_58">/20&nbsp;页</span>
          </div>
        </div>
      </div>
      <FooterVue style="margin-bottom: 0"></FooterVue>
    </div>

  </div>
</template>
<script>
import HeadVue from "../common/HeadVue.vue";
import FooterVue from "../common/FooterVue.vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name:'index',
  components: {
    HeadVue,
    FooterVue
  },
  data() {
    return {
      searchText: '',
      currentIndex: 0,
      btnList: [
        '全部场景',
        'ERP/生产',
        '进销存/仓储',
        'HR/OA',
        '工单/调度',
        '项目/任务',
        '其他'
      ],
      filterIndex: 0,
      filterList: ['全部', '其他条件', '免费', '免费试用'],
      selectedPageSize: 8,  // 默认选中8条/页
      pageSizes: [8, 10],
      currentPageNum: 1,
      currentPage: 1,
      totalPages: 11,
      jumpPage: 1,
    };
  },
  methods: {
    handleClick(index) {
      this.currentIndex = index;
    },
    handleFilterClick(index) {  // 添加筛选项点击处理方法
      this.filterIndex = index;
    },
    handlePageNumClick(page) {
      this.currentPageNum = page;
    },
    handlePageClick(page) {
      if (page !== '...') {
        this.currentPage = page
      }
    },
    handlePageChange(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
      }
    },
    handleJumpPage() {
      if (this.jumpPage >= 1 && this.jumpPage <= this.totalPages) {
        this.currentPage = this.jumpPage
      }
    }
  },
  created() {
    // 组件创建时默认选中"全部"按钮
    this.filterIndex = 0;
  },
  computed: {
    displayPages() {
      const current = this.currentPage
      const total = this.totalPages
      let pages = []

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i)
        }
      } else {
        pages.push(1)
        if (current > 3) {
          pages.push('...')
        }
        const start = Math.max(2, current - 1)
        const end = Math.min(current + 1, total - 1)
        for (let i = start; i <= end; i++) {
          pages.push(i)
        }
        if (current < total - 2) {
          pages.push('...')
        }
        if (current !== total) {
          pages.push(total)
        }
      }
      return pages
    }
  },
};
</script>
<style scoped lang="css" src="./assets/index.css" />
